export { wrapPageElement } from "./wrapPageElement"

const showLoadedMainImages = () => {
  document.querySelectorAll("img[data-main-image]").forEach(img => {
    const reveal = () => {
      img.style.opacity = "1"
      const placeholder = img
        .closest(".gatsby-image-wrapper")
        ?.querySelector("[data-placeholder-image]")
      if (placeholder) placeholder.style.opacity = "0"
    }
    if (img.complete && img.naturalWidth > 0) {
      reveal()
    } else {
      img.addEventListener("load", reveal, { once: true })
    }
  })
}

export const onInitialClientRender = () => {
  showLoadedMainImages()
}

export const onRouteUpdate = () => {
  requestAnimationFrame(showLoadedMainImages)
}
